import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { SharedModule } from '@tv3/shared/shared.module'
import { ChannelsLibraryModule } from '@tokeet-frontend/channels'
import { ReviewsLibraryModule } from '@tokeet-frontend/reviews'
import { ReviewReplyDialogComponent } from './components/review-reply-dialog/review-reply-dialog.component'
import { ReviewCategoryTagsComponent } from './components/review-category-tags/review-category-tags.component'
import { ChannelReviewsTableComponent } from './components/channel-reviews-table/channel-reviews-table.component'
import { TemplatesSharedModule } from '../templates/templates-shared.module'
import { ReviewAirbnbGuestDialogComponent } from './components/review-airbnb-guest-dialog/review-airbnb-guest-dialog.component'
import { ReviewAirbnbGuestDialogService } from './components/review-airbnb-guest-dialog/review-airbnb-guest-dialog.service'
import { ReviewVrboGuestDialogService } from './components/review-vrbo-guest-dialog/review-vrbo-guest-dialog.service'
import { BookingRatingDialogService } from './components/booking-rating-dialog/booking-rating-dialog.dialog.service'
import { BookingRatingDialogComponent } from './components/booking-rating-dialog/booking-rating-dialog.component'
import { BookingRatingComponent } from './components/booking-rating/booking-rating.component'
import { ReviewCategoryPipe } from './pipes/review-category.pipe'
import { ReviewVrboGuestDialogComponent } from './components/review-vrbo-guest-dialog/review-vrbo-guest-dialog.component'
import { AirbnbBookingReviewComponent } from './components/booking-review/airbnb-booking-review/airbnb-booking-review.component'
import { VrboBookingReviewComponent } from './components/booking-review/vrbo-booking-review/vrbo-booking-review.component'
import { BookingReviewComponent } from './components/booking-review/booking-review.component'
import { RentalReviewInsightsComponent } from './components/rental-review-insights/rental-review-insights.component'
import { UnlockRentalReviewInsightsComponent } from './components/unlock-rental-review-insights/unlock-rental-review-insights.component'
import { RentalReviewInsightsDialogComponent } from './components/rental-review-insights-dialog/rental-review-insights-dialog.component'
import { RentalReviewInsightsDialogService } from './components/rental-review-insights-dialog/rental-review-insights-dialog.dialog.service'
import { ReviewInsightsGuestSentimentsDialogService } from './components/review-insights-guest-sentiments-dialog/review-insights-guest-sentiments-dialog.dialog.service'
import { ReviewInsightsGuestSentimentsDialogComponent } from './components/review-insights-guest-sentiments-dialog/review-insights-guest-sentiments-dialog.component'
import { BdcBookingReviewComponent } from './components/booking-review/bdc-booking-review/bdc-booking-review.component'
import { ExpediaBookingReviewComponent } from './components/booking-review/expedia-booking-review/expedia-booking-review.component'

const components = [
  //
  ReviewReplyDialogComponent,
  ReviewCategoryTagsComponent,
  ChannelReviewsTableComponent,
  AirbnbBookingReviewComponent,
  VrboBookingReviewComponent,
  BdcBookingReviewComponent,
  ExpediaBookingReviewComponent,
  BookingReviewComponent,
  ReviewAirbnbGuestDialogComponent,
  ReviewVrboGuestDialogComponent,
  BookingRatingDialogComponent,
  BookingRatingComponent,
  RentalReviewInsightsComponent,
  UnlockRentalReviewInsightsComponent,
  RentalReviewInsightsDialogComponent,
  ReviewInsightsGuestSentimentsDialogComponent,
]

const services = [
  //
  ReviewAirbnbGuestDialogService,
  ReviewVrboGuestDialogService,
  BookingRatingDialogService,
  RentalReviewInsightsDialogService,
  ReviewInsightsGuestSentimentsDialogService,
]

const modules = [
  //
  SharedModule,
  ChannelsLibraryModule,
  ReviewsLibraryModule,
  TemplatesSharedModule,
]

@NgModule({
  declarations: [
    //
    ...components,
    ReviewCategoryPipe,
  ],
  imports: [
    //
    CommonModule,
    ...modules,
  ],
  exports: [
    //
    ...modules,
    ...components,
  ],
  providers: [
    //
    ...services,
  ],
})
export class ReviewsSharedModule {}
